import type { FlowItem } from "../Types/BookShipmentFlowItemType";

export function bookShipmentGetPreviousInFlow(
  flow: Array<FlowItem>,
  currentIdentifier: string,
): string {
  const currentIndex = flow.findIndex(function (item) {
    return item.identifier === currentIdentifier;
  });

  if (currentIndex === -1) {
    throw new Error("Item not found");
  }

  if (currentIndex === 0) {
    // First so there is no previous
    throw new Error("Already at start of flow");
  }

  const previous = flow[currentIndex - 1];
  if (previous === undefined) {
    throw new Error("Already at start of flow");
  }

  return previous.identifier;
}
